import {  MainImages } from "@lemon/assets";

export const dummyData = {
    id: 1,
    brand_name: '코랄리',
    product_name: '틴트',
    color: 'red',
    product_image: MainImages.tint,
    beauty: {
        personalColor: '웜톤',
        personalDetailColor: '웜톤',
    },
    // 데이터 어떻게 들어올지 몰라서 임의로 만들어 놓음
    toneMap: {
        light: 1,
        bright: 0,
        murky: 0,
        dark: 0,
    },
    colorSenseBar: {
        //온도감
        temperature: 3,
        //채도
        saturation: 5,
        // 명도
        brightness: 5,
        //탁도
        contrast: 1,
    },
    // 같은 제품이 포함된 파우치
    sameItemInPouch: [
        {
            id: 1,
            nickname: '파우치주인장',
            thumbnail: MainImages.pouch,
            title: '내 여름 파우치를 공개합니다. 여름뮤트 파우치에요',
            scrap: 292,
        },
        {
            id: 2,
            nickname: '파우치주인장',
            thumbnail: MainImages.pouch,
            title: '내 여름 파우치를 공개합니다. 여름뮤트 파우치에요',
            scrap: 292,
        },
        {
            id: 3,
            nickname: '파우치주인장',
            thumbnail: MainImages.pouch,
            title: '내 여름 파우치를 공개합니다. 여름뮤트 파우치에요',
            scrap: 292,
        },
    ],
};
